import { FlatTreeControl } from '@angular/cdk/tree';
import { ExpandableResource } from './expandable-resource';
/**
 * L2-S1/T7: moved from `src/app/shared/components/create-select-folders/helpers/get-parent-node.ts`
 * so `CreateSelectFoldersComponent` could move to @miq/platform-ui. Sits next to
 * `expandable-resource`, the model it walks. The old host path is a re-export shim.
 */
/** getParentNode
 * @param treeNodeControl FlatTreeControl
 * @param node TreeMatNode
 */
export const getParentNode = (
  treeNodeControl: FlatTreeControl<ExpandableResource<any>>,
  node: ExpandableResource<any>
): ExpandableResource<any> | any | null => {
  const currentLevel = treeNodeControl.getLevel(node);
  if (currentLevel < 1) {
    return null;
  }
  const startIndex = treeNodeControl.dataNodes.indexOf(node) - 1;
  for (let i = startIndex; i >= 0; i--) {
    const currentNode = treeNodeControl.dataNodes[i];
    if (treeNodeControl.getLevel(currentNode) < currentLevel) {
      return currentNode;
    }
  }
  return null;
};
